import { useRoutes, Navigate } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import Login from './pages/Login';
import Register from './pages/Register';
import Products from './pages/Products';
import Blog from './pages/Blog';
import User from './pages/User';
import NotFound from './pages/Page404';
import AddProject from './pages/AddProject';
import AddVideoProject from './pages/AddVideoProject';
import Projects from './pages/Projects';
import Employees from './pages/Employees';
import AddEmployee from './pages/AddEmployee';
import MoveEmployee from './pages/MoveEmployee';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import JoinUsPage from './pages/JoinUsPage';
import { RequireAuth } from './hooks/useAuth';
import { Add3DProjects } from './pages/Add3dProjects';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="projects" replace />
        },
        {
          path: 'employees',
          children: [
            {
              path: '',
              element: (
                <RequireAuth>
                  <Employees />
                </RequireAuth>
              )
            },
            {
              path: 'add',
              element: (
                <RequireAuth>
                  <AddEmployee />
                </RequireAuth>
              )
            },
            {
              path: ':id',
              element: (
                <RequireAuth>
                  <AddEmployee />
                </RequireAuth>
              )
            },
            {
              path: 'move',
              element: (
                <RequireAuth>
                  <MoveEmployee />
                </RequireAuth>
              )
            }
          ]
        },
        {
          path: 'projects',
          children: [
            {
              path: '',
              element: (
                <RequireAuth>
                  <Projects />
                </RequireAuth>
              )
            },
            {
              path: 'add',
              children: [
                {
                  path: '',
                  element: (
                    <RequireAuth>
                      <AddProject />
                    </RequireAuth>
                  )
                },
                {
                  path: 'video',
                  element: (
                    <RequireAuth>
                      <AddVideoProject />
                    </RequireAuth>
                  )
                },
                {
                  path: '3d',
                  element: (
                    <RequireAuth>
                      <Add3DProjects />
                    </RequireAuth>
                  )
                }
              ]
            },
            {
              path: ':id',
              children: [
                {
                  path: '',
                  element: (
                    <RequireAuth>
                      <AddProject />
                    </RequireAuth>
                  )
                },
                {
                  path: 'video',
                  element: (
                    <RequireAuth>
                      <AddVideoProject />
                    </RequireAuth>
                  )
                },
                {
                  path: '3d',
                  element: (
                    <RequireAuth>
                      <Add3DProjects />
                    </RequireAuth>
                  )
                }
              ]
            }
          ]
        },
        {
          path: 'pages',
          children: [
            {
              path: 'about',
              element: (
                <RequireAuth>
                  <AboutPage />
                </RequireAuth>
              )
            },
            {
              path: 'join-us',
              element: (
                <RequireAuth>
                  <JoinUsPage />
                </RequireAuth>
              )
            },
            {
              path: 'contact',
              element: (
                <RequireAuth>
                  <ContactPage />
                </RequireAuth>
              )
            }
          ]
        },
        {
          path: 'user',
          element: (
            <RequireAuth>
              <User />
            </RequireAuth>
          )
        },
        {
          path: 'products',
          element: (
            <RequireAuth>
              <Products />
            </RequireAuth>
          )
        },
        { path: 'blog', element: <Blog /> }
      ]
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'login', element: <Login /> },
        { path: 'register', element: <Register /> },
        { path: '*', element: <NotFound /> }
      ]
    },
    { path: '*', element: <NotFound /> }
  ]);
}
